module.exports = __webpack_public_path__ + "img/img_lianghua_fengkuong@3x.5b4eed02.png";